module.exports = __webpack_public_path__ + "img/UI_common_framelabelBX_01_03cd3f6a5.png";